export var InternalHandlers;
(function (InternalHandlers) {
    InternalHandlers["AggregateItems"] = "aggregate-items";
    InternalHandlers["CreateEntity"] = "create-entity";
    InternalHandlers["UpdateEntity"] = "update-entity";
    InternalHandlers["DeleteData"] = "delete-data";
    InternalHandlers["DeleteItemMeta"] = "delete-item-meta";
    InternalHandlers["GetData"] = "get-data";
    InternalHandlers["GetPropertyDataHistory"] = "get-property-data-history";
    InternalHandlers["GetDefinition"] = "get-definition";
    InternalHandlers["GetDefinitions"] = "get-definitions";
    InternalHandlers["GetDisplayData"] = "get-display-data";
    InternalHandlers["GetItemExpanded"] = "get-item-expanded";
    InternalHandlers["GetItemMeta"] = "get-item-meta";
    InternalHandlers["GetItemMetas"] = "get-item-metas";
    InternalHandlers["GetItemsByPropertyValue"] = "get-items-by-property-value";
    InternalHandlers["ImportEntities"] = "import-entities";
    InternalHandlers["ListAllItemIds"] = "list-all-item-ids";
    InternalHandlers["ListData"] = "list-data";
    InternalHandlers["ListItemMetas"] = "list-item-metas";
    InternalHandlers["SaveData"] = "save-data";
    InternalHandlers["SaveDefinition"] = "save-definition";
    InternalHandlers["SaveItemMeta"] = "save-item-meta";
    InternalHandlers["SearchItems"] = "search-items";
    InternalHandlers["SearchItemsExpanded"] = "search-items-expanded";
    InternalHandlers["ClearScrollId"] = "clear-scroll-id";
    InternalHandlers["SearchRelatedItemsExpanded"] = "search-related-items-expanded";
    InternalHandlers["ValidateEntity"] = "validate-entity";
    InternalHandlers["RestoreData"] = "restore-data";
})(InternalHandlers || (InternalHandlers = {}));
//# sourceMappingURL=types.js.map